/**
 * Fill Later work queue (POM-6149).
 *
 * Only SCHEDULED and WAITING_SHIPMENT rows can be acted on (Create now / Change the date /
 * Cancel). The backend enforces the same rule on every mutation, so this Set only decides what
 * the row menu offers; it never has to be the last line of defence.
 */
export const FILL_LATER_ACTIONABLE_STATUSES = new Set(['SCHEDULED', 'WAITING_SHIPMENT']);

/** Statuses the tab shows by default; Created, Cancelled and Merged are opt-in via the filter. */
export const FILL_LATER_DEFAULT_STATUSES = ['SCHEDULED', 'WAITING_SHIPMENT', 'FAILED'];

export const FILL_LATER_STATUS_LABEL = {
  SCHEDULED: 'Scheduled',
  WAITING_SHIPMENT: 'Waiting on previous shipment',
  CREATED: 'Created',
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
  MERGED: 'Merged',
};

/** Shown on hover over the status chip, where the short label needs spelling out. */
export const FILL_LATER_STATUS_TOOLTIP = {
  WAITING_SHIPMENT: 'Blocked because the previous order has not shipped',
  CANCELLED:
    'Cancelled with the work it belonged to. The quantity set aside for it was not added back to' +
    ' the prescription.',
};

export const FILL_LATER_STATUS_OPTIONS = Object.entries(FILL_LATER_STATUS_LABEL).map(
  ([value, label]) => ({ value, label })
);

export const FILL_LATER_TYPE_LABEL = {
  SPLIT_BY_QUANTITY: 'Split by quantity',
  SOURCE_BY_ORDER: 'Source by order',
  SOURCE_BY_ITEM: 'Source by item',
};

export const FILL_LATER_TYPE_TOOLTIP = {
  SPLIT_BY_QUANTITY:
    'Part of the quantity came off the order. The original keeps the rest and ships as normal.',
  SOURCE_BY_ORDER: 'The whole order was moved to Fill Later. Every item on it has its own row.',
  SOURCE_BY_ITEM:
    'The whole item was moved to Fill Later. Nothing was left on the order to fill now.',
};

export const FILL_LATER_TYPE_OPTIONS = Object.entries(FILL_LATER_TYPE_LABEL).map(
  ([value, label]) => ({ value, label })
);

/**
 * How the Create now dialog reports each FillLaterOutcome from createFillLaterItemNow
 * (POM-6150). NOT_DUE cannot come back from Create now (the mutation ignores the date) but is
 * mapped so an unexpected value still reads sensibly.
 */
export const FILL_LATER_CREATE_NOW_OUTCOME = {
  CREATED: {
    variant: 'success',
    message: ({ splitOrderId }) => `Order ${splitOrderId} created for the split quantity`,
  },
  AWAITING_SHIPMENT: {
    variant: 'warning',
    message: ({ reason }) =>
      `Item is now waiting on shipment${reason ? `: ${reason}` : ''}. It will be created once the original order ships.`,
  },
  ALREADY_HANDLED: {
    variant: 'info',
    message: ({ reason }) => `This item was already handled${reason ? `: ${reason}` : ''}.`,
  },
  NOT_DUE: {
    variant: 'warning',
    message: ({ reason }) => `Item is not due yet${reason ? `: ${reason}` : ''}.`,
  },
  FAILED: {
    variant: 'error',
    message: ({ reason }) => `Could not create the order${reason ? `: ${reason}` : ''}.`,
  },
};
